import { useFormItemContext } from './FormItemContext.tsx';

export function useFormItemEnabled() {
  const {
    enabled,
    layoutEnabled,
    /**
     * Il form item può richiedere di essere visivamente disabilitato, in ogni
     * caso il valore finale di `visuallyDisabled` sarà `true` se
     * `enabled` o `layoutEnabled` sono `false`, a prescindere dal valore
     * richiesto dal form item.
     */
    visuallyDisabled: requestVisuallyDisabled,
  } = useFormItemContext();

  const visuallyDisabled =
    enabled === false ||
    layoutEnabled === false ||
    Boolean(requestVisuallyDisabled);

  return { enabled, layoutEnabled, visuallyDisabled };
}
